import FilterForm from "../../../component/FilterForm/FilterForm";
import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import Select from "react-select";
import {entradaTypeList} from "./entradaTypeList";
import {ApiUrl} from "../../../auth/authMethods";
import SelectInput from "../../../component/SelectInput";

export default function FilterInstallmentPattern({filter, setFilter, setLoadData, setPage}) {

    const [lgShow, setLgShow] = useState(false);
    const [nome, setNome] = useState('');
    const [entrada, setEntrada] = useState('')

    const [padraoList, setPadraoList] = useState('')
    const [padraoId, setPadraoId] = useState('')



    const handlesSubmit = (e) => {

        e.preventDefault();
        let filterData = {}
        if (padraoId)
            filterData.id = padraoId
        if (entrada)
            filterData.entrada = entrada

        console.log(filterData);

        setFilter(filterData);
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const clearFilter = () => {
        setPadraoId('')
        setEntrada('')
        setFilter({});
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 0}
        >

            <SelectInput
                url={ApiUrl + '/padrao-parcelamento/list/select'}
                placeholder={"Nome"}
                list={padraoList}
                set={setPadraoList}
                setObj={setPadraoId}
                defaultValue={padraoId}
                returnList={() => {
                    let returnList = []
                    padraoList.forEach((item) => {
                        returnList.push({value: item.id, label: `${item.nome}`})
                    })
                    return returnList
                }}
                readContent={(data) => {return data}}
                isClearable
                fullWidth
            />
            <Select
                className="basic-single"
                classNamePrefix="select"
                id="form_select"
                required={false}
                defaultValue={entradaTypeList.filter(item => item.value === entrada)}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                options={entradaTypeList}
                onChange={(e) => setEntrada(e?.value)}
                placeholder={'Entrada'}
            />
        </FilterForm>
    </>
}